export const initialState = {
    basket: [], 
    cdetails: [], 
    productDetalis: [],
    user: [],
    email: [],
    checkuser: false,
    deliveryfees: 0,
    admnavagationoption: 'zero',
    pagNum: 0,
};

export const getBasketTotal = (basket) =>
    basket?.reduce((amount, item) => item.price*item.qnt + amount, 0);

    const reducer = (state, action) => {
        //console.log(action);
        switch(action.type){

            case 'ADD_TO_BASKET':
                return{
                    ...state,
                    basket: [...state.basket, action.item],
                };
            
            case 'EMPTY_TO_BASKET':
                return{
                    ...state,
                    basket: []
                };
    
            case 'REMOVE_FROM_BASKET':
                const index = state.basket.findIndex(
                    (basketItem) => basketItem.id === action.id
                );
                let newBasket = [...state.basket];
    
                if(index >= 0){
                    newBasket.splice(index, 1);
                } else{
                    console.warn(
                        `Cant remove product (id: ${action.id}) as its not in basket!`
                    )
                }
                return{
                    ...state,
                    basket: newBasket
                }

            case 'ADD_TO_Qnt':
                /*const updateBasket = state.basket.map(item => (item.id === action.id ? { ...item, qnt: action.qnt } : item));*/
                const indexqnt = state.basket.findIndex(
                    (basketItem) => basketItem.id === action.id
                );

                var newItem = {
                    id: action.id,
                    title: action.title,
                    price: action.price,
                    img: action.img,
                    qnt: action.qnt
                }

                let updateBasket = [...state.basket];

                updateBasket.splice(indexqnt, 1, newItem)

                return{
                    ...state,
                    basket: updateBasket
                }

            case 'SUB_TO_Qnt':
                /*const updateBasket = state.basket.map(item => (item.id === action.id ? { ...item, qnt: action.qnt } : item));*/
                const indexSub = state.basket.findIndex(
                    (basketItem) => basketItem.id === action.id
                );

                var newItemSub = {
                    id: action.id,
                    title: action.title,
                    price: action.price,
                    img: action.img,
                    qnt: action.qnt
                }

                let updateBasketSub = [...state.basket];

                updateBasketSub.splice(indexSub, 1, newItemSub)

                return{
                    ...state,
                    basket: updateBasketSub
                }

            case 'SET_CDETAILS':
                return{
                    ...state,
                    cdetails: [action.item]
                }

            case 'SET_PRODUCTDETAILS':
                return{
                    ...state,
                    productDetalis: [action.item]
                }

            case 'SET_USER':
                return{
                    ...state,
                    user: action.user,
                }

            case 'SET_EMAIL':
                return{
                    ...state,
                    email: action.email,
                };

            case 'SET_CHECHUSER':
                return{
                    ...state,
                    checkuser: action.checkuser,
                };

            case 'SET_DELIVERYFESS':
                return{
                    ...state,
                    deliveryfees: action.deliveryfees,
                };

            case 'SET_ADMNO':
                return{
                    ...state,
                    admnavagationoption: action.admnavagationoption,
                };

            case 'PAGNUM':
                return{
                    ...state,
                    pagNum: action.pagNum,
                };
                
            default:
                return state;
        }
    };
    
    export default reducer;